import { t } from 'i18next';
import type { components } from '@pocapan/shared/types/schema';
import { formatDateTime } from '@pocapan/shared/utils/DateUtil';

export type BettieTransactionItemProps = {
  item: components['schemas']['ApiV1BettieTransaction'];
};

const BettieTransactionItem = ({ item }: BettieTransactionItemProps) => {
  const getTransactionType = (
    transactionType: 'earned' | 'used' | 'refunded' | 'expired' | 'adjusted' | 'released'
  ) => {
    switch (transactionType) {
      case 'earned':
        return t('BettieUsage.transaction.earned');
      case 'used':
        return t('BettieUsage.transaction.used');
      case 'refunded':
        return t('BettieUsage.transaction.refunded');
      case 'expired':
        return t('BettieUsage.transaction.expired');
      case 'adjusted':
        return '-';
      case 'released':
        return '-';
    }
  };

  const isCharge = item.transactionType === 'earned';
  return (
    <div key={item.transactionId} className="w-full">
      <div className="w-full flex items-center justify-between py-[16px]">
        <div className="flex items-center gap-[12px] min-w-0">
          <div className="flex flex-col gap-[6px] min-w-0">
            <p className="text-[16px] font-medium text-text-main-lv2 leading-[19px] truncate">
              {getTransactionType(item.transactionType)}
            </p>
            <p className="text-[13px] text-text-main-lv4 leading-[16px] truncate">
              {item.sourceName}
            </p>
          </div>
        </div>
        <div className="flex flex-col items-end gap-[4px] flex-shrink-0">
          <span
            className={`text-[16px] font-semibold ${isCharge ? 'text-primary-light dark:text-primary-dark' : 'text-text-main-lv2'}`}
          >
            {isCharge && '+'}
            {t('BettieUsage.count', { count: item.amount })}
          </span>
          <span className="text-[13px] text-text-main-lv4 leading-[16px]">
            {formatDateTime(item.occurredAt, 'HH:mm')}
          </span>
        </div>
      </div>
      <hr className="w-full border-surface-lv2" />
    </div>
  );
};

export default BettieTransactionItem;
